import { AxiosError } from 'axios';
import { GET_ADMIN_ANNOUNCEMENT_CONFIGS_QUERY_KEY } from 'web-library/constants/queryKeys';
import { GET_ADMIN_ANNOUNCEMENT_CONFIGS } from 'web-library/constants/apiUrls';
import { AnnouncementConfigs } from 'web-library/models/Announcements';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: AnnouncementConfigs) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAdminAnnouncementConfigs = ({ onSuccess, onError }: Input) => {
  const getAdminAnnouncementConfigs = async () => {
    const res = await axiosClient.get<AnnouncementConfigs>(GET_ADMIN_ANNOUNCEMENT_CONFIGS);
    return res.data;
  };
  return useCustomQuery([GET_ADMIN_ANNOUNCEMENT_CONFIGS_QUERY_KEY], getAdminAnnouncementConfigs, {
    onSuccess,
    onError,
  });
};
